// extracted by mini-css-extract-plugin
export default {"open":"body_open__JIl1S","close":"body_close__OSDDE"};